var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-top-shell"},[_c('router-view',{attrs:{"name":"header"}}),(_vm.pageHeader)?_c('admin-page-header-view',{attrs:{"header":_vm.pageHeader.header}}):_vm._e(),_c('router-view',{staticClass:"min-vh-100 ds-top-main"}),_c('router-view',{attrs:{"name":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }